import { useEffect, useState } from 'react';

const cheatCode = 'dev_power';
export const useSecretCode = () => {
  const [showComponent, setShowComponent] = useState(false);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      //@ts-ignore
      if (window.cheatCode === cheatCode) {
        setShowComponent(true);
      }
    });

    observer.observe(document.body, { attributes: true, childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);
  return showComponent;
};
